import { isOnlineAtom } from './recoilState';
import { getGoogleProfile } from 'auth';
import { atom, selector } from 'recoil';
import { UserProfile } from 'Types';

export const isSignInModalOpenAtom = atom({
  key: 'isSignInModalOpenAtom',
  default: false,
});

export const googleUserAtom = atom<UserProfile | null>({
  key: 'googleUserAtom',
  default: getGoogleProfile(),
});

export const facebookUserAtom = atom<UserProfile | null>({
  key: 'facebookUserAtom',
  default: null,
});

export const selectAccessTokens = selector({
  key: 'selectAccessTokens',
  get: ({ get }) => {
    return {
      google: get(googleUserAtom)?.accessToken ?? null,
      facebook: get(facebookUserAtom)?.accessToken ?? null,
    };
  },
});

export const selectUserProfile = selector({
  key: 'selectUserProfile',
  get: ({ get }) => {
    if (!get(isOnlineAtom)) {
      return null;
    }

    return get(googleUserAtom) ?? get(facebookUserAtom) ?? null;
  },
});

export const selectUserName = selector({
  key: 'selectUserName',
  get: ({ get }) => {
    return get(selectUserProfile)?.name ?? null;
  },
});

export const selectUserImage = selector({
  key: 'selectUserImage',
  get: ({ get }) => {
    return get(selectUserProfile)?.image ?? null;
  },
});
